export function albumPages(album) {
  return { name: 'albumPages', params: { id: album.id, slug: album.slug } }
}

export function albumEdit(album) {
  return { name: 'albumEdit', params: { id: album.id, slug: album.slug } }
}

export function albumShare(album) {
  return { name: 'albumShare', params: { id: album.id, slug: album.slug } }
}

export function viewAlbum(album) {
  return { name: 'viewAlbum', params: { id: album.id, slug: album.slug } }
}

export function shareAlbum(album) {
  return { name: 'albumShare', params: { id: album.id, slug: album.slug } }
}

export function viewPage(albumId, pageId) {
  return { name: 'viewPage', params: { id: albumId, pageId } }
}

export function bulkEditPages(album) {
  return { name: 'albumPagesEdit', params: { id: album.id, slug: album.slug } }
}

export function viewProfile(user) {
  return { name: 'viewProfile', params: { id: user.id, username: user.username } }
}

export function editPage(album, pageId) {
  return { name: 'pageEdit', params: { id: album.id, slug: album.slug, pageId } }
}

export function getExternalLoginLink() {
  const redirectUri = encodeURIComponent(window.location.origin + '/auth/callback')
  return `https://${process.env.AUTH0_DOMAIN}/authorize?client_id=${process.env.AUTH0_CLIENT_ID}&scope=${encodeURIComponent('openid profile email')}&redirect_uri=${redirectUri}&response_type=code`
}
